import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  key: 1
};
const _hoisted_2 = {
  class: "topbar"
};
import { useRoutesStore } from '@/store/modules/routes';
import { translate } from '@/i18n';
import { handleMatched } from '@/utils/routes';
import { House, Switch } from '@element-plus/icons-vue';
import { useUserStore } from '~/src/store/modules/user';

import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { ref, computed, onMounted } from 'vue';
import axios from 'axios';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const router = useRouter();
    const routesStore = useRoutesStore();
    const userStore = useUserStore();
    const {
      getRoutes: routes
    } = storeToRefs(routesStore);
    const roleList = ref([]);
    const breadcrumbList = computed(() => handleMatched(routes.value, route.path).filter(item => !item.meta.breadcrumbHidden));
    const handleTo = (path = '') => {
      return {
        path
      };
    };
    const customIndex = () => {
      router.push({
        path: '/index/custom'
      });
    };
    const switchIndex = id => {
      localStorage.setItem(`${userStore.userId}${sessionStorage.getItem('belongId')}homeModuleId`, id);
      router.push({
        path: '/index/index',
        query: {
          id
        }
      });
    };
    onMounted(async () => {
      roleList.value = await axios.get(`/api/identity/home-module-template/home-module-roles-template-label`);
      const savedId = localStorage.getItem(`${userStore.userId}${sessionStorage.getItem('belongId')}homeModuleId`);
      if (savedId) {
        let val = roleList.value.find(d => d.value == savedId);
        if (!val) {
          localStorage.removeItem(`${userStore.userId}${sessionStorage.getItem('belongId')}homeModuleId`);
        }
      }
      if (route.path === '/index/index' && !route.query.id && roleList.value.length > 0) {
        // 优先用上次记住的 id，没有再用第一个
        let homeModuleId = localStorage.getItem(`${userStore.userId}${sessionStorage.getItem('belongId')}homeModuleId`);
        const targetId = homeModuleId ?? roleList.value[0].value;
        switchIndex(targetId);
      }
    });
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
      return _openBlock(), _createBlock(_component_el_breadcrumb, {
        class: "vab-breadcrumb",
        separator: ">"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(breadcrumbList), (item, index) => {
          return _openBlock(), _createBlock(_component_el_breadcrumb_item, {
            key: index,
            to: handleTo(item.redirect)
          }, {
            default: _withCtx(() => [item.meta.icon ? (_openBlock(), _createBlock(_component_vab_icon, {
              key: 0,
              icon: item.meta.icon,
              "is-custom-svg": item.meta.isCustomSvg
            }, null, 8, ["icon", "is-custom-svg"])) : _createCommentVNode("", true), item.meta.title ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_unref(translate)(item.meta.title)), 1)) : _createCommentVNode("", true)]),
            _: 2
          }, 1032, ["to"]);
        }), 128)), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
          icon: _unref(House),
          text: "",
          onClick: customIndex
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("自定义首页", -1)]))]),
          _: 1
        }, 8, ["icon"]), _createVNode(_component_el_dropdown, {
          trigger: 'click',
          class: "switch"
        }, {
          dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(roleList), item => {
              return _openBlock(), _createBlock(_component_el_dropdown_item, {
                onClick: $event => switchIndex(item.value),
                class: "is-active"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["onClick"]);
            }), 256))]),
            _: 1
          })]),
          default: _withCtx(() => [_createVNode(_component_el_button, {
            text: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, {
              size: 16
            }, {
              default: _withCtx(() => [_createVNode(_unref(Switch))]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })])]),
        _: 1
      });
    };
  }
});